/** COMMERCE-174A — scannable QR SVG from the provider public receipt URL. */
// @ts-expect-error vendored uqr ESM (no types)
import { encode } from "./uqr.js";

export function fiscalQrSvg(url: string): string {
  const value = String(url ?? "").trim();
  if (!/^https:\/\//i.test(value)) return "";
  const result = encode(value, { ecc: "M", boostEcc: true }) as {
    data: boolean[][];
    size: number;
  };
  const size = Number(result.size) || 0;
  if (size < 21) return "";
  const paths: string[] = [];
  for (let y = 0; y < size; y++) {
    const row = result.data[y] ?? [];
    for (let x = 0; x < size; x++) {
      if (row[x]) paths.push(`M${x},${y}h1v1h-1z`);
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges" role="img" aria-label="QR"><rect width="${size}" height="${size}" fill="#fff"/><path fill="#111" d="${paths.join("")}"/></svg>`;
}
